import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { PlatformService } from '@core/services/util/platform.service';
import { StorageService } from '@core/services/util/storage.service';

@Injectable({
    providedIn: 'root'
})

export class AuthGuard  {

    constructor(
        private router: Router,
        private storageService: StorageService,
        private platformService: PlatformService
    ) { }

    isAuthenticated(): boolean {
        if (this.storageService.get('session-id') && this.storageService.get('phone_no')) {
            return true;
        }
        return false;
    }

    canActivate(
        _active: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (this.platformService.isServer() || this.isAuthenticated()) {
            return true;
        }
        this.router.navigate(['/'], { queryParams: { returnUrl: state.url, mode: 'authentication' }, skipLocationChange: true });
        return false;
    }
}
